@if (loginStateService.loggedIn) {
  <div class="holder">
    <app-status></app-status>
    <div id="cert-holder">
      <div class="select-title">{{strings.artesStrings['LANGUAGE']}}</div>
      @if (auth.isAdmin) {
        <div class="certificate-input" id="select-language">
          <div class="action-container">
            <mat-select [(value)]="holderService.holder.active_certificate.language" (selectionChange)="setCertificateLanguage($event.value)" [disabled]="!auth.isAdmin">
              @for (language of constantsService.constants.languages; track language) {
                <mat-option [value]="language">
                  {{language.label}}
                </mat-option>
              }
            </mat-select>
          </div>
        </div>
      }
      <div style="clear:both"></div>
      <div id="certificate">
        @if (state===1) {
          <app-certificate-front [holder]="holderService.holder" [strings]="strings.certificateStrings" class="page" (click)="state=2"></app-certificate-front>
        }
        @if (state===2) {
          <app-certificate-back [holder]="holderService.holder" [strings]="strings.certificateStrings" class="page" (click)="state=1"></app-certificate-back>
        }
      </div>
      @if (auth.isAdmin) {
        <div class="select-title">{{strings.artesStrings['ACTION']}}</div>
      }
      @if (auth.isAdmin) {
        <div class="action-container">
          <mat-select [(value)]="selectedAction">
            @for (action of actions; track action) {
              <mat-option [value]="action">{{action.label}}</mat-option>
            }
          </mat-select>
        </div>
      }
      @if (auth.isAdmin) {
        <button id="action-button" (click)="performAction(selectedAction)">{{strings.artesStrings['PERFORM_ACTION']}}</button>
      }
    </div>
  </div>
}
